<template>
  <layout name="Clean">
    <div class="v-not-found-page__wrapper">
      <div class="v-not-found-page__top-bar">
        <div class="left-block">
          <div class="logo"><img :src="logo" alt="campaign-logo" /></div>
        </div>
        <div class="right-block">
          <div v-if="!isAuthenticated" class="btn-wrapper">
            <VButton
              label="Log in"
              size="narrow"
              noBorder
              inverted
              :onClickHandler="() => navigate('/')"
            ></VButton>
            <VButton
              label="Demo"
              size="regular"
              :onClickHandler="
                () => externalBlank('https://www.inkit.com/demo/')
              "
            ></VButton>
          </div>
        </div>
      </div>
      <div class="v-not-found-page__content">
        <div class="image-and-description">
          <div class="error-image-wrapper">
            <img :src="page404" />
          </div>
          <p class="error-description">
            The requested page does not exist.
          </p>
        </div>

        <div class="error-additional-text">
          <p class="top">
            Try double-checking your URL or visiting our
            <v-link routerLink="/" label="homepage" />.
          </p>
          <p>
            Need access to Inkit?
            <v-link routerLink="/login" label="Log in" /> or
            <v-link href="mailto:sales@inkit.com" label="contact sales" />.
          </p>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";

//components
import Layout from "@/layouts/Layout";
import VLink from "@/components/VLink";
import VButton from "@/components/VButton";

//mixins
import withNavigate from "@/mixins/withNavigate";

//images
import NotFoundPage from "@/assets/images/error-404.svg";
import CampaignLogo from "@/assets/images/campaign_logo.svg";

export default Vue.component("ServerError", {
  metaInfo: {
    title: "Not Found"
  },

  components: {
    Layout,
    VLink,
    VButton
  },

  mixins: [withNavigate],

  data() {
    return {
      logo: CampaignLogo,
      page404: NotFoundPage
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"])
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-not-found-page";
.#{$ns}__wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Lato-Light", Arial, "Helvetica Neue", Helvetica, sans-serif;
  color: $secondary-grey;

  .#{$ns}__top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 100px;
    width: 100%;

    .logo {
      img {
        height: 50px;
      }
    }

    .btn-wrapper {
      :first-child {
        margin-right: 30px;
      }
    }
  }

  .#{$ns}__content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .error-image-wrapper {
    margin-bottom: 60px;
  }
  .error-description {
    text-align: center;
    font-size: 36px;
    margin-bottom: 125px;
  }

  .error-additional-text {
    font-size: 22px;
    line-height: 1.2;
    padding-bottom: 30px;


    p {
      text-align: center;
      a {
        font-size: inherit;
      }
    }
    .top {
      margin-bottom: 50px;
    }
  }
}

/*Media*/
@media screen and (max-width: $medium-screen) {
  .#{$ns}__wrapper {
    .#{$ns}__top-bar {
      padding: 0 20px;
    }
  }
}

@media screen and (max-width: $small-screen) {
  .#{$ns}__wrapper {
    .error-description {
      font-size: 20px;
    }

    .#{$ns}__top-bar {
      .logo {
        img {
          height: 30px;
        }
      }
      .btn-wrapper {
        :first-child {
          margin-right: 15px;
        }
      }

      /deep/ button {
        width: 50px;
      }
    }

    .error-image-wrapper {
      margin-bottom: 40px;
      img {
        height: 110px;
      }
    }

    .error-additional-text {
      font-size: 14px;

      .top {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
